import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Container, FilterButton, FilterItem, FiltersContainer } from "./styles";
import { ReactComponent as FilterIcon } from '../../assets/icons/filter.svg';
import { useTranslation } from "react-i18next";
import {Checkbox} from "../CheckBox";

interface FilterProps {
    filters: string[];
    selectedFilters: string[];
    setSelectedFilters: Function;
}

export const Filter = ({ filters, selectedFilters, setSelectedFilters }: FilterProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const filtersContainerRef = useRef<HTMLUListElement>(null);
    const filterButtonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                filtersContainerRef.current &&
                !filtersContainerRef.current.contains(event.target as Node) &&
                filterButtonRef.current !== event.target
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const { t } = useTranslation()

    const handleFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;
        const { id: key } = e.target;

        setSelectedFilters((prevState: string[]) => {
            if (checked) {
                return [...prevState, key];
            } else {
                return prevState.filter((k) => k !== key);
            }
        });
    };

    const toggleDropdown = () => {
        setIsOpen(prevState => !prevState);
    };

    return (
        <Container>
            <FilterButton ref={filterButtonRef} onClick={toggleDropdown} active={selectedFilters.length > 0}>
                <FilterIcon />
                <p>{t('filter')}</p>
            </FilterButton>
            {isOpen && (
                <FiltersContainer ref={filtersContainerRef}>
                    {filters.map((f, i) => (
                        <FilterItem key={i}>
                            <Checkbox
                                style={{ marginRight: '15px' }}
                                id={f}
                                checked={selectedFilters.includes(f)}
                                onChange={(e) => handleFilterChange(e)}
                            />
                            {t(f)}
                        </FilterItem>
                    ))}
                </FiltersContainer>
            )}
        </Container>
    );
}
